import PropTypes from 'prop-types'
import styled from 'styled-components'

import { styles } from '../button'
import { SDB, SDR, SO, SY } from '../../colors'

const colors = {
  default: SY,
  blue: SDB,
  red: SDR,
  orange: SO
}
const padding = {
  medium: '3px',
  large: '5px'
}
const getFontSize = ({ innerVariant }) => {
  if (/larger-text/.test(innerVariant)) {
    return 'font-size: 18px'
  }

  return null
}
const getPadding = ({ innerVariant, size }) => {
  if (innerVariant !== 'flatter') {
    return null
  }

  return `
    padding-top: ${padding[size]};
    padding-bottom: ${padding[size]};
  `
}
const getBackgroundColor = ({ innerVariant, display }) => {
  if (/invert/.test(innerVariant)) {
    return 'white'
  }

  return colors[display]
}
const getHoverBackgroundColor = ({ innerVariant, display }) => {
  if (/invert/.test(innerVariant)) {
    return colors[display]
  }

  return 'white'
}
const getBorderColor = ({ display, innerVariant }) => {
  if (display === 'default') {
    return /invert/.test(innerVariant) ? colors.default : 'white'
  }

  return colors[display]
}
const getColor = ({ innerVariant, display }) => {
  if (display === 'default') {
    return 'black'
  }

  if (/invert/.test(innerVariant)) {
    return colors[display]
  }

  return 'white'
}
const getHoverColor = ({ innerVariant, display }) => {
  if (display === 'default') {
    return 'black'
  }

  if (/invert/.test(innerVariant)) {
    return 'white'
  }

  return colors[display]
}
const Button = styled.button`
  ${styles};
  ${getFontSize};
  ${getPadding};
  color: ${getColor};
  border-width: 1px;
  border-color: ${getBorderColor};
  background-color: ${getBackgroundColor};

  &:hover {
    color: ${getHoverColor};
    border-color: ${({ display }) => colors[display]};
    background-color: ${getHoverBackgroundColor};
  }

  span {
    width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'auto')};
  }
`
const PromoButton = ({
  children,
  variant,
  size = 'medium',
  display = 'default',
  align = 'left',
  isFullWidth = false,
  ...rest
}) => {
  return (
    <Button
      size={size}
      display={display}
      align={align}
      isFullWidth={isFullWidth}
      innerVariant={variant}
      variant="cta"
      {...rest}>
      <span>{children}</span>
    </Button>
  )
}

PromoButton.propTypes = {
  variant: PropTypes.oneOf(['larger-text', 'flatter', 'invert', 'invert-larger-text']),
  size: PropTypes.oneOf(['medium', 'large']),
  align: PropTypes.oneOf(['left', 'right', 'center']),
  display: PropTypes.oneOf(['default', 'blue', 'red', 'orange']),
  isFullWidth: PropTypes.bool
}

export { PromoButton }
